import { render, staticRenderFns } from "./UserListaEncuestas.vue?vue&type=template&id=545d068e&scoped=true"
import script from "./UserListaEncuestas.vue?vue&type=script&lang=js"
export * from "./UserListaEncuestas.vue?vue&type=script&lang=js"
import style0 from "./UserListaEncuestas.vue?vue&type=style&index=0&id=545d068e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d068e",
  null
  
)

export default component.exports